import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const defaultExpertiseData = [
    {
        title: "Cloud and Workspace Architecture",
        desc: "Design Databricks workspaces and environments for your organization, cloud platform, security model, and delivery lifecycle.",
    },
    {
        title: "Data Ingestion and Pipelines",
        desc: "Design Databricks workspaces and environments for your organization, cloud platform, security model, and delivery lifecycle.",
    },
    {
        title: "Governance and Access Controls",
        desc: "Design Databricks workspaces and environments for your organization, cloud platform, security model, and delivery lifecycle.",
    },
    {
        title: "Deployment Automation",
        desc: "Design Databricks workspaces and environments for your organization, cloud platform, security model, and delivery lifecycle.",
    },
    {
        title: "Performance and Cost Optimization",
        desc: "Design Databricks workspaces and environments for your organization, cloud platform, security model, and delivery lifecycle.",
    },
    {
        title: "Enablement and Operational Handover",
        desc: "Design Databricks workspaces and environments for your organization, cloud platform, security model, and delivery lifecycle.",
    },
];

export const WhyPartnerWithUs = ({
    badge = "Databricks consulting FAQs",
    heading = "Good questions. Clear answers.",
    subheading = "  Everything you need to understand lakehouse architecture, data migration, and building a modern data platform.",
    faqData = defaultExpertiseData,
    bgImageSrc = "/assets/datab/bg2.png",
}) => {
    const [openIndex, setOpenIndex] = useState(null);

    const toggleAccordion = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <section className="relative w-full overflow-hidden bg-[#001744] py-[80px] lg:py-[124px]">
            <div className="absolute inset-0 z-0 pointer-events-none">
                <img
                    src={bgImageSrc}
                    alt="Databricks consulting background"
                    className="w-full h-full object-cover object-left"
                />
                {/* <div className="absolute inset-0 bg-gradient-to-r from-[#001744]/90 via-[#001744]/75 to-[#001744]/85" /> */}
            </div>

            <div className="relative z-10 max-w-[1440px] mx-auto px-[20px] lg:px-[80px]">
                <div className="flex flex-col lg:flex-row items-start justify-between gap-10 lg:gap-16">
                    <div className="w-full max-w-[336px]">
                        <h2 className="text-white text-[20px] lg:text-[30px] font-[600] font-sora leading-[1.18] tracking-[-0.02em] mb-[8px] sm:mb-[13px]">
                            {heading}
                        </h2>
                        {/* <p className="text-white font-graphik text-[14px] md:text-[16px] font-[500] leading-[1.65] max-w-[420px]">
                            {subheading}
                        </p> */}
                    </div>

                    <div className="w-full lg:w-[65%] grid grid-cols-1 md:grid-cols-2 gap-4 items-start">
                        {faqData.map((item, index) => {
                            const isOpen = openIndex === index;

                            return (
                                <div
                                    key={item.title || index}
                                    className="border border-white/50 bg-white/[0.03] backdrop-blur-sm transition-all duration-300 hover:border-white/40"
                                >
                                    <button
                                        type="button"
                                        onClick={() => toggleAccordion(index)}
                                        className="w-full text-left p-5 sm:p-6 flex items-center justify-between gap-4 cursor-pointer"
                                    >
                                        <span className="text-white font-sora text-[14px] sm:text-[16px] font-[600] leading-snug">
                                            {item.title}
                                        </span>
                                        <span className="text-white/80 text-[20px] font-light flex-shrink-0 transition-transform duration-300">
                                            {isOpen ? "−" : "+"}
                                        </span>
                                    </button>

                                    <AnimatePresence initial={false}>
                                        {isOpen && (
                                            <motion.div
                                                initial={{ opacity: 0, height: 0 }}
                                                animate={{ opacity: 1, height: "auto" }}
                                                exit={{ opacity: 0, height: 0 }}
                                                transition={{ duration: 0.3, ease: "easeInOut" }}
                                                className="overflow-hidden"
                                            >
                                                <div className="px-5 pb-5 sm:px-6 sm:pb-6 pt-0 border-t border-white/40">
                                                    <p className="text-white font-graphik text-[12px] sm:text-[14px] font-[500] leading-[1.6] pt-3">
                                                        {item.desc}
                                                    </p>
                                                </div>
                                            </motion.div>
                                        )}
                                    </AnimatePresence>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default WhyPartnerWithUs;